import React from 'react';

import { Chip, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useInitialLetterFilter } from './hooks';

export const InitialLetterFilter: React.FC<EmptyProps> = () => {
	const {
		data: { filters, resultsAreFiltered },
		actions: { updateFilter, clearFilters },
	} = useInitialLetterFilter();

	return (
		<div className="space-y-4">
			<Text>
				<Translate value="corgi.topic_page_sitemap.topic_list.filter" />
			</Text>

			<ul className="flex flex-wrap gap-2">
				<li>
					<Chip
						data-qa="all-chip"
						as="button"
						className="min-w-8 shrink-0"
						onClick={() => clearFilters()}
						active={!resultsAreFiltered}
						aria-pressed={!resultsAreFiltered}
					>
						<Translate value="corgi.topic_page_sitemap.topic_list.all_filter" />
					</Chip>
				</li>
				{filters.map((option) => (
					<li key={option.name}>
						<Chip
							aria-pressed={option.selected}
							active={option.selected}
							onClick={() => updateFilter(option.name)}
							className="px-2.5"
							size="small"
							data-qa={`${option.name}-filter`}
						>
							{option.name}
						</Chip>
					</li>
				))}
			</ul>
		</div>
	);
};
